import React from 'react';
import Relay from 'react-relay';

class UserItem extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false
        }
    }

    componentDidMount() {
        this.refetchUser()
    }

    refetchUser = () => {
        this.setState({isLoading: true}, () => {
            this.props.relay.forceFetch({
                userId: this.props.userId,
                queryUser: !!this.props.userId
            }, state => {
                this.setState({isLoading: false})
            })
        })
    }

    _switchButton(user){
        if (!user.isTrustedUserToCreateActivities) {
            return (
                <button 
                    type="button" 
                    className="btn btn-success btn-sm" 
                    onClick={() => this.props.validateUser(user, this.refetchUser)}
                >
                    Validate user
                </button>
            )
        }
        else {
            return (
                <button 
                    type="button" 
                    className="btn btn-danger btn-sm" 
                    onClick={() => this.props.unvalidateUser(user, this.refetchUser)}
                >
                    Unvalidate user
                </button>
            )
        }
    }

    render() {
        const { viewer: {user}, index, isActiveLine } = this.props ;

        if (this.props.loading || !user) 
            return (<div>Loading...</div>)


        let filter = this.props.filter; 

        const { pseudo, sex, reporters, creation_status, avatar, sports, isTrustedUserToCreateActivities, creation_date } = user;
        const status = creation_status.status;

        let imageSrc = avatar ? avatar : '';
        
        let reportersNb = 0 ;
        if (reporters)
            reportersNb = reporters.length;
        
        let pendingCertificates = 0;

        if (sports && sports.length > 0) {
            sports.forEach(sport => {
                if (sport.certificates && sport.certificates.length > 0) {
                sport.certificates.forEach(certificate => {
                    if (certificate.validation == "PENDING")
                    pendingCertificates++;
                })
                }
            })
        }      
        
        if (filter == "Reported" && reportersNb < 1)
            return ;
        if (filter == "Blocked" && status == "VALID")
            return ;
        
        let activeClass = isActiveLine ? 'active' : null;
        
        return (
            <tr className={activeClass}
                key={index}
            >
                <td onClick={()=>{this.props._highlightLine(index); this.props.onItemClick(user, index)}}>{index}</td>
                <td onClick={()=>{this.props._highlightLine(index); this.props.onItemClick(user, index)}}><img src={imageSrc} style={{height:20}}/></td>
                <td onClick={()=>{this.props._highlightLine(index); this.props.onItemClick(user, index)}}>{pseudo}</td>
                <td onClick={()=>{this.props._highlightLine(index); this.props.onItemClick(user, index)}}>{creation_date}</td>
                <td onClick={()=>{this.props._highlightLine(index); this.props.onItemClick(user, index)}}>{sex}</td>
                <td onClick={()=>{this.props._highlightLine(index); this.props.onItemClick(user, index)}}>{status}</td>
                <td onClick={()=>{this.props._highlightLine(index); this.props.onItemClick(user, index)}}>{reportersNb}</td>
                <td onClick={()=>{this.props._highlightLine(index); this.props.onItemClick(user, index)}}>{pendingCertificates}</td>
                <td>{!this.state.isLoading && this._switchButton(user)}</td>
            </tr>
        );

    }

}

UserItem.propTypes = ({
  user: React.PropTypes.object.isRequired,
  relay: React.PropTypes.object.isRequired,
});

export default Relay.createContainer(UserItem, {
    initialVariables: {
        userId: null,
        queryUser: false 
    },
    fragments: {
        viewer: () => Relay.QL`
            fragment on Viewer {
                user (id: $userId) @include (if: $queryUser) {
                    id,
                    pseudo,
                    avatar,
                    creation_date,
                    sex,
                    fees,
                    isTrustedUserToCreateActivities,
                    isTrustedUserToMakeMoneyTransferToAnyone,
                    lastConnexionDate,
                    authorized_managers {
                        authorization_level
                        user {
                            id
                        }
                    }
                    address {
                        address,
                        zip,
                        city,
                        country
                    },
                    sports {
                        certificates {
                            validation
                        }
                    }
                    reporters {
                        reason
                    }
                    creation_status {
                        status,
                    }
                }
            }
        `,
    }
});



// WEBPACK FOOTER //
// ./src/components/UserItem.js